import { type FC } from 'react';
import { ToastProvider } from '@heroui/react';

// Native HeroUI positioning: top-center, offset below the ~75px app header so toasts don't
// overlap it (mirrors where the legacy ngToast appeared). HeroUI's own horizontal centering for
// this placement didn't take effect via the provider, so the card is centered explicitly with
// `mx-auto` in showToast's classNames instead.
export const AppToastProvider: FC = () => (
    <ToastProvider placement="top-center" maxVisibleToasts={3} toastOffset={80} />
);
